"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushToTalkButton = void 0;

var react_1 = __importStar(require("react"));

var react_client_1 = require("@speechly/react-client");

var pubsub_js_1 = __importDefault(require("pubsub-js"));

var types_1 = require("../types");

var __1 = require("..");

var styled_components_1 = __importDefault(require("styled-components"));

var PushToTalkButton = function PushToTalkButton(_a) {
  var _b = _a.powerOn,
      powerOn = _b === void 0 ? false : _b,
      _c = _a.hide,
      hide = _c === void 0 ? false : _c,
      captureKey = _a.captureKey,
      size = _a.size,
      _d = _a.gradientStops,
      gradientStops = _d === void 0 ? ['#15e8b5', '#4fa1f9'] : _d,
      _e = _a.intro,
      intro = _e === void 0 ? 'Hold to talk' : _e,
      _f = _a.hint,
      hint = _f === void 0 ? 'Hold to talk' : _f,
      _g = _a.fontSize,
      fontSize = _g === void 0 ? '100%' : _g,
      showTime = _a.showTime,
      _h = _a.textColor,
      textColor = _h === void 0 ? '#ffffff' : _h,
      backgroundColor = _a.backgroundColor,
      placement = _a.placement,
      voffset = _a.voffset,
      _j = _a.tapToTalkTime,
      tapToTalkTime = _j === void 0 ? 8000 : _j,
      _k = _a.silenceToHangupTime,
      silenceToHangupTime = _k === void 0 ? 1000 : _k;

  var _l = (0, react_client_1.useSpeechContext)(),
      client = _l.client,
      clientState = _l.clientState,
      initialize = _l.initialize,
      startContext = _l.startContext,
      stopContext = _l.stopContext,
      segment = _l.segment;

  var _m = (0, react_1.useState)(false),
      loaded = _m[0],
      setLoaded = _m[1];

  var _o = (0, react_1.useState)(react_client_1.ClientState.Disconnected),
      icon = _o[0],
      setIcon = _o[1];

  var _p = (0, react_1.useState)(intro),
      hintText = _p[0],
      setHintText = _p[1];

  var _q = (0, react_1.useState)(true),
      showHint = _q[0],
      setShowHint = _q[1];

  var _r = (0, react_1.useState)(powerOn === true),
      usePermissionPriming = _r[0],
      setUsePermissionPriming = _r[1];

  var buttonStateRef = (0, react_1.useRef)({
    tapListenActive: false,
    wasListening: false,
    holdListenActive: false,
    tapListenTimeout: null,
    tangentPressPromise: null
  });
  var buttonRef = (0, react_1.useRef)();
  var clientStateRef = (0, react_1.useRef)();
  var TAP_TRESHOLD_MS = 600;
  var PERMISSION_PRE_GRANTED_TRESHOLD_MS = 1500; // make stateRef always have the current count
  // your "fixed" callbacks can refer to this object whenever
  // they need the current value.  Note: the callbacks will not
  // be reactive - they will not re-run the instant state changes,
  // but they *will* see the current value whenever they do run

  clientStateRef.current = clientState; // Dynamic import of HTML custom element to play nice with Next.js SSR

  (0, react_1.useEffect)(function () {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var import1, import2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              import1 = Promise.resolve().then(function () {
                return __importStar(require('@speechly/browser-ui/core/holdable-button'));
              });
              import2 = Promise.resolve().then(function () {
                return __importStar(require('@speechly/browser-ui/core/call-out'));
              });
              return [4
              /*yield*/
              , Promise.all([import1, import2])];

            case 1:
              _a.sent();

              setLoaded(true);
              return [2
              /*return*/
              ];
          }
        });
      });
    })();
  }, []); // Use browser API only after mount to play nice with Next.js SSR

  (0, react_1.useEffect)(function () {
    if (powerOn === 'auto') {
      setUsePermissionPriming(localStorage.getItem("SpeechlyFirstConnect"
      /* SpeechlyFirstConnect */
      ) === null);
    }
  }, [powerOn]);
  (0, react_1.useEffect)(function () {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) {
      var button = buttonRef.current;
      button.onholdstart = tangentPressAction;
      button.onholdend = tangentReleaseAction;
    }
  });
  (0, react_1.useEffect)(function () {
    // Change button face according to Speechly states
    setIcon(clientState);

    if (clientState >= react_client_1.ClientState.Connected) {
      setUsePermissionPriming(false); // Set connect made

      if (localStorage.getItem("SpeechlyFirstConnect"
      /* SpeechlyFirstConnect */
      ) === null) {
        localStorage.setItem("SpeechlyFirstConnect"
        /* SpeechlyFirstConnect */
        , String(Date.now()));
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [clientState]);

  var tangentPressAction = function tangentPressAction() {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        buttonStateRef.current.tangentPressPromise = function () {
          return __awaiter(void 0, void 0, void 0, function () {
            var _a, initStartTime, err_1, err_2;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  pubsub_js_1.default.publish(types_1.SpeechlyUiEvents.TangentPress, {
                    state: clientStateRef.current
                  });
                  window.postMessage({
                    type: 'holdstart',
                    state: clientStateRef.current
                  }, '*');
                  setShowHint(false);
                  if (!usePermissionPriming) return [3
                  /*break*/
                  , 1];
                  window.postMessage({
                    type: "speechlypoweron"
                    /* speechlypoweron */

                  }, '*');
                  return [3
                  /*break*/
                  , 14];

                case 1:
                  if (buttonStateRef.current.tapListenTimeout) {
                    window.clearTimeout(buttonStateRef.current.tapListenTimeout);
                    buttonStateRef.current.tapListenTimeout = null;
                  }

                  _a = clientStateRef.current;

                  switch (_a) {
                    case react_client_1.ClientState.Disconnected:
                      return [3
                      /*break*/
                      , 2];
                  }

                  return [3
                  /*break*/
                  , 7];

                case 2:
                  initStartTime = Date.now();
                  _b.label = 3;

                case 3:
                  _b.trys.push([3, 5,, 6]);

                  return [4
                  /*yield*/
                  , initialize()];

                case 4:
                  _b.sent();

                  return [3
                  /*break*/
                  , 6];

                case 5:
                  err_1 = _b.sent();
                  console.error('Error initiasing Speechly', err_1);
                  return [3
                  /*break*/
                  , 6];

                case 6:
                  // await buttonStateRef.current.initPromise
                  // Long init time suggests permission dialog --> prevent listening start
                  buttonStateRef.current.holdListenActive = !powerOn && Date.now() - initStartTime < PERMISSION_PRE_GRANTED_TRESHOLD_MS;
                  return [3
                  /*break*/
                  , 8];

                case 7:
                  buttonStateRef.current.holdListenActive = true;
                  return [3
                  /*break*/
                  , 8];

                case 8:
                  if (!client) return [3
                  /*break*/
                  , 13];
                  if (!buttonStateRef.current.holdListenActive) return [3
                  /*break*/
                  , 12];
                  buttonStateRef.current.wasListening = client.isListening();
                  if (!!client.isListening()) return [3
                  /*break*/
                  , 12];
                  _b.label = 9;

                case 9:
                  _b.trys.push([9, 11,, 12]);

                  return [4
                  /*yield*/
                  , startContext()];

                case 10:
                  _b.sent();

                  return [3
                  /*break*/
                  , 12];

                case 11:
                  err_2 = _b.sent();
                  console.error('Error while starting to record', err_2);
                  return [3
                  /*break*/
                  , 12];

                case 12:
                  return [3
                  /*break*/
                  , 14];

                case 13:
                  throw Error('No Speechly client (are you using Speechly in non-browser environment?)');

                case 14:
                  return [2
                  /*return*/
                  ];
              }
            });
          });
        }();

        return [2
        /*return*/
        ];
      });
    });
  };

  var tangentReleaseAction = function tangentReleaseAction(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            // Ensure async tangentPress and Release are run in appropriate order
            return [4
            /*yield*/
            , buttonStateRef.current.tangentPressPromise];

          case 1:
            // Ensure async tangentPress and Release are run in appropriate order
            _a.sent();

            pubsub_js_1.default.publish(types_1.SpeechlyUiEvents.TangentRelease, {
              state: clientStateRef.current,
              timeMs: event.timeMs
            });
            window.postMessage({
              type: 'holdend'
            }, '*');

            if (buttonStateRef.current.holdListenActive) {
              buttonStateRef.current.holdListenActive = false;

              if (event.timeMs < TAP_TRESHOLD_MS) {
                if (tapToTalkTime === 0) {
                  stopListening();
                  setHintText(hint);
                  setShowHint(true);
                } else {
                  // Tap: toggle listening on/off
                  if (buttonStateRef.current.wasListening) {
                    stopListening();
                  } else {
                    // schedule "silence based stop"
                    setStopContextTimeout(tapToTalkTime);
                  }
                }
              } else {
                stopListening();
              }
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var setStopContextTimeout = function setStopContextTimeout(timeoutMs) {
    buttonStateRef.current.tapListenActive = true;

    if (buttonStateRef.current.tapListenTimeout) {
      window.clearTimeout(buttonStateRef.current.tapListenTimeout);
    }

    buttonStateRef.current.tapListenTimeout = window.setTimeout(function () {
      buttonStateRef.current.tapListenTimeout = null;
      stopListening();
    }, timeoutMs);
  };

  var stopListening = function stopListening() {
    buttonStateRef.current.tapListenActive = false;

    if (client === null || client === void 0 ? void 0 : client.isListening()) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        stopContext();
      } catch (err) {
        console.error('Error while stopping recording', err);
      }
    }
  };
  /**
   * Extend listening time if segment updates received
   */


  (0, react_1.useEffect)(function () {
    if (segment) {
      if (buttonStateRef.current.tapListenTimeout) {
        setStopContextTimeout(silenceToHangupTime);
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [segment]);
  if (!loaded) return null;
  return react_1.default.createElement(MicButtonDiv, {
    textColor: textColor,
    fontSize: fontSize
  }, placement === 'bottom' && react_1.default.createElement(__1.PushToTalkButtonContainer, {
    size: size,
    voffset: voffset
  }, react_1.default.createElement("holdable-button", {
    ref: buttonRef,
    poweron: powerOn,
    capturekey: captureKey,
    icon: icon,
    size: size,
    gradientstop1: gradientStops[0],
    gradientstop2: gradientStops[1],
    hide: hide ? 'true' : 'false'
  }), react_1.default.createElement("call-out", {
    show: showHint && hintText !== '',
    backgroundcolor: backgroundColor,
    showtime: showTime
  }, hintText)), placement !== 'bottom' && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("holdable-button", {
    ref: buttonRef,
    poweron: powerOn,
    capturekey: captureKey,
    icon: icon,
    size: size,
    gradientstop1: gradientStops[0],
    gradientstop2: gradientStops[1],
    hide: hide ? 'true' : 'false'
  }), react_1.default.createElement("call-out", {
    show: showHint && hintText !== '',
    backgroundcolor: backgroundColor,
    showtime: showTime
  }, hintText)));
};

exports.PushToTalkButton = PushToTalkButton;
var MicButtonDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: 'Saira Condensed', sans-serif;\n  color: ", ";\n  font-size: ", ";\n  line-height: 120%;\n  text-transform: uppercase;\n"], ["\n  font-family: 'Saira Condensed', sans-serif;\n  color: ", ";\n  font-size: ", ";\n  line-height: 120%;\n  text-transform: uppercase;\n"])), function (props) {
  return props.textColor;
}, function (props) {
  return props.fontSize;
});
var templateObject_1;